import { AvailableLanguages } from '@repo/toolkit/language-types'
import { z } from 'zod'

import { t } from '../../../locale/utils'

/**
 * This is used for the text editor context/ body
 */
export const RICH_TEXT_SCHEMA = (lng: AvailableLanguages) =>
  z
    .string({
      required_error: t('errors.rich.text.required', { lng })
    })
    .min(1, {
      message: t('errors.rich.text.required', { lng })
    })
    .refine(
      (value) => {
        // Check if body has any non-HTML content
        const strippedValue = value.replace(/<[^>]*>?/gm, '').trim()
        return strippedValue.length > 0
      },
      {
        message: t('errors.rich.text.invalid', { lng })
      }
    )
